// Ajustes › Páginas (padrão do app todo) e Ajustes › Abas › [aba] › Páginas desta aba (0.65, C6).
import { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import type { AbaId, ConfigPaginas } from '../store/types';
import { CONFIG_PADRAO, configDoApp, salvarConfigAba, salvarConfigApp, useConfigPaginas } from '../lib/paginas';
import { FolhaOpcoes } from './Quadro';
import { PaletaCores } from './PaletaCores';
import { C } from './theme';
import { t } from '../lib/i18n';

/** Folha e bolinhas (editor). */
function EditorConfig({ c, cor, onMudar }: { c: ConfigPaginas; cor: string; onMudar: (c: ConfigPaginas) => void }) {
  const [paleta, setPaleta] = useState<number | null>(null);
  return (
    <View style={{ gap: 12 }}>
      <FolhaOpcoes folha={c.folha} cor={cor} onMudar={p => onMudar({ ...c, folha: { ...c.folha, ...p } })} />
      <Text style={{ color: C.sub, fontSize: 12, fontWeight: '800' }}>{t('AS 4 BOLINHAS DE COR')}</Text>
      <View style={{ flexDirection: 'row', gap: 12 }}>
        {c.bolinhas.map((b, i) => <Pressable key={i} onPress={() => setPaleta(i)} style={{ width: 36, height: 36, borderRadius: 18, backgroundColor: b, borderWidth: 1, borderColor: C.line }} />)}
      </View>
      <Text style={{ color: C.sub, fontSize: 12 }}>{t('São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.')} {t('Na página, segurar a bolinha faz o mesmo.')}</Text>
      <Pressable onPress={() => onMudar(CONFIG_PADRAO)}><Text style={{ color: cor, fontWeight: '700' }}>↩︎ {t('Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)')}</Text></Pressable>
      <PaletaCores visivel={paleta !== null} atual={paleta !== null ? c.bolinhas[paleta] : ''} onFechar={() => setPaleta(null)}
        onEscolher={x => { if (paleta === null) return; const b = [...c.bolinhas]; b[paleta] = x; onMudar({ ...c, bolinhas: b }); }} />
    </View>
  );
}

/** Ajustes › Páginas: muda o padrão do app todo. */
export function PaginasDoApp({ cor }: { cor: string }) {
  const { config } = useConfigPaginas(null);
  return (
    <View style={{ backgroundColor: C.card, borderRadius: 16, padding: 14, gap: 12 }}>
      <Text style={{ color: C.sub, fontSize: 12 }}>{t('Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.')}</Text>
      <EditorConfig c={config} cor={cor} onMudar={salvarConfigApp} />
    </View>
  );
}

/** Ajustes › Abas › [aba] › Páginas desta aba: "Usar o padrão do app" ou "Personalizar". */
export function PaginasDaAba({ aba, cor }: { aba: AbaId; cor: string }) {
  const { config, personalizada } = useConfigPaginas(aba);
  return (
    <View style={{ backgroundColor: C.card, borderRadius: 16, padding: 14, gap: 12 }}>
      <Pressable onPress={() => salvarConfigAba(aba, null)} style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
        <Text style={{ color: C.text, fontSize: 18 }}>{!personalizada ? '◉' : '○'}</Text>
        <Text style={{ color: C.text, flex: 1 }}>{t('Usar o padrão do app')}</Text>
      </Pressable>
      <Pressable onPress={() => { if (!personalizada) salvarConfigAba(aba, configDoApp()); }} style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
        <Text style={{ color: C.text, fontSize: 18 }}>{personalizada ? '◉' : '○'}</Text>
        <Text style={{ color: C.text, flex: 1 }}>{t('Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba')}</Text>
      </Pressable>
      {personalizada && <EditorConfig c={config} cor={cor} onMudar={c => salvarConfigAba(aba, c)} />}
    </View>
  );
}
